<div>
  @if (singleItemsLoading$ | async) {
    <div class="relative p-8">
      <fip-loading-spinner class="left-2/4 top-2/4"></fip-loading-spinner>
    </div>
  } @else {
    <fip-table
      [columns]="cols"
      [displayedColumns]="colsDisplay"
      [data]="(singleItems$ | async) ?? []"
      [paginated]="true"
    ></fip-table>
  }
</div>
